// Realisation.vue file

<template>
  <div class="realisation">
    <!-- DEBUT BANNIERE -->

    <div class="ban"></div>
    <div class="container">
      <div class="page page_real">
        <!-- DEBUT FIL D'ARIANE -->

        <nav aria-label="Breadcrumb" class="breadcrumb">
          <ul>
            <li>
              <router-link to="/">ACCUEIL</router-link>
            </li>
            <li>
              <router-link class="prev-page" to="/prestations.html"
                >NOS PRESTATIONS</router-link
              >
            </li>
            <li class="bc-li real_page">
              <span aria-current="page" class="current-page">
                {{ dataArray[currentArticle].titleA }}
              </span>
            </li>
          </ul>
        </nav>
        <!-- FIN FIL D'ARIANE -->

        <div class="real_container">
          <div class="r_img slider-container">
            <div class="slide fade" v-for="(img, idxImg) in imgArray[currentArticle]" :key="idxImg">
              <a
                  :href="
                    imageUrl(
                      dataArray[currentArticle].idA,
                      img
                    )
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    :src="
                      imageUrl(
                        dataArray[currentArticle].idA,
                        img
                      )
                    "
                    :alt="dataArray[currentArticle].titleA"
                  />
                </a>
            </div>

            <div class="content_dots" v-if="imgArray[currentArticle].length > 1">
              <span class="dot" v-for="(image, index) in imgArray[currentArticle]" :key="index" @click="showSlides(index)"></span>
            </div>
          </div>

          <div class="r_content">
            <div class="r_txt">
              <h1>{{ dataArray[currentArticle].titleA }}</h1>
              <div v-html="changeDescribeUrl(dataArray[currentArticle].describeA)"></div>
            </div>
          </div>
        </div>
        <!-- <div class="next_prev">
          <div class="prev">
            <a @click="navigation(-1)"><i class="fas fa-chevron-left"></i></a>
          </div>
          <div class="next">
            <a @click="navigation(1)"><i class="fas fa-chevron-right"></i></a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { prestaMixin } from "../mixins/prestaMixin";
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Réalisation de l'entreprise d'électricité BOAS située à Gimont dans le Gers et spécialisée dans l'électricité générale, secteur tertiaire et industiel, la domotique, les panneaux photovoltaïques, le chauffage et la climatisation."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content: "Réalisation, Électricité, BOAS, Gimont, Gers"
      }
    ]
  },
  name: "realisation",
  mixins: [prestaMixin, titleMixin],
  data() {
    return {
      title: "",
      dataArray: "",
      id: this.$route.params.id,
      currentArticle: null,
      indexArray: [],
      slideIndex: 0,
      idxImg: 0
    };
  },
  beforeMount() {
    this.detailsProd();

  },
  mounted() {
    // this.showSlides(this.slideIndex)
  },
  methods: {
    detailsProd() {
      for (let i = 0; i < this.dataArray.length; i++) {
        this.indexArray.push(this.dataArray[i]["idA"]);
      }
      const findIndexArray = element => element == this.id;
      this.currentArticle = this.indexArray.findIndex(findIndexArray);
      this.title =
        this.dataArray[this.currentArticle]["titleA"] +
        " Réalisation entreprise BOAS";
    },
    navigation(direction) {
      let nextValue = this.currentArticle + direction;
      if (nextValue >= this.dataArray.length) {
        nextValue = 0;
      } else if (nextValue < 0) {
        nextValue = this.dataArray.length - 1;
      }
      this.currentArticle = nextValue;
      this.idxImg ++
            this.showSlides(0)

    },
    showSlides(n) {
      var images = document.getElementsByClassName('slide');
      for(var i = 0; i < images.length; i++) {
        images[i].style.display = "none";
      }
      if(n > images.length - 1) {
        this.slideIndex = 0;
      }
      images[n].style.display = "block";
      n ++
    },
    currentSlide(n) {
      var newIndex = n
      this.showSlides(newIndex);
    }
  }
};
</script>

<style scoped>
.realisation .fad {
  font-size: 2rem;
  color: black;
}
.page_real {
  position: relative;
}
.next_prev {
  position: absolute;
  width: 100%;
  height: 50px;
  top: 50%;
}
.prev,
.next {
  cursor: pointer;
  font-size: 2rem;
}
.fa-chevron-left {
  float: left;
}
.fa-chevron-right {
  float: right;
}
.prev-page {
  margin-left: 6px;
}
.real_container {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: auto;
  margin-top: 3rem;
}
.r_img,
.r_content {
  width: 49%;
  z-index: 1;
}
.r_img img {
  max-width: 100%;
}
.r_img ul {
  margin: 0;
  padding: 0;
}
.r_img li {
  list-style-type: none;
}
@media all and (max-width: 1000px) {
  .r_content h1 {
    font-size: 1.2rem;
  }
}

@media all and (max-width: 760px) {
  .real_container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .r_img,
  .r_content {
    text-align: center;
    width: 100%;
    font-size: 0.7rem;
  }
}
@media all and (max-width: 400px) {
  .r_content {
    font-size: 0.6rem;
  }
}
.slide {
  display: none;
}
.content_dots {
  display: flex;
  justify-content: center;
}
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: rgba(90, 90, 90, 0.85);
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}
.active, .dot:hover {
  background-color: #000000;
}
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

</style>
